import type { Region } from '../types'

export const regions: Region[] = [
  {
    id: 'north-central',
    name: 'North Central',
    states: ['Benue', 'Kogi', 'Kwara', 'Nasarawa', 'Niger', 'Plateau', 'FCT'],
    headline: 'Secure the food basket, then industrialise it.',
    detail:
      'Farmer–herder conflict has taken productive land out of use across the middle belt. The plan pairs a dedicated rural security corps with agro-processing zones in Benue, Niger and Plateau so that what is grown here is finished here.',
    priorities: ['Rural security corps', 'Agro-processing zones', 'Middle-belt rail spur'],
  },
  {
    id: 'north-east',
    name: 'North East',
    states: ['Adamawa', 'Bauchi', 'Borno', 'Gombe', 'Taraba', 'Yobe'],
    headline: 'Recovery that outlasts the emergency.',
    detail:
      'Reconstruction moves from relief to livelihoods: rebuilt schools and clinics, resettlement with land title, and solar mini-grids for communities the national grid will not reach this decade.',
    priorities: ['Resettlement with land title', 'School reconstruction', 'Solar mini-grids'],
  },
  {
    id: 'north-west',
    name: 'North West',
    states: ['Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Sokoto', 'Zamfara'],
    headline: 'End banditry. Put the largest population to work.',
    detail:
      'Intelligence-led operations across the Zamfara–Katsina corridor, backed by the textile and leather revival that once employed hundreds of thousands in Kano and Kaduna.',
    priorities: ['Corridor security operations', 'Textile & leather revival', 'Almajiri education reform'],
  },
  {
    id: 'south-east',
    name: 'South East',
    states: ['Abia', 'Anambra', 'Ebonyi', 'Enugu', 'Imo'],
    headline: 'Back the manufacturers who are already building.',
    detail:
      'Aba, Nnewi and Onitsha need power, credit and export logistics far more than they need new policy. An industrial power compact and a dry port at Enugu are the first commitments.',
    priorities: ['Industrial power compact', 'Enugu dry port', 'Erosion control programme'],
  },
  {
    id: 'south-south',
    name: 'South South',
    states: ['Akwa Ibom', 'Bayelsa', 'Cross River', 'Delta', 'Edo', 'Rivers'],
    headline: 'Clean it up, then move beyond oil.',
    detail:
      'Enforced remediation timelines in the Niger Delta, a gas-to-industry corridor, and maritime training that puts Nigerians on Nigerian-flagged vessels.',
    priorities: ['Delta remediation enforcement', 'Gas-to-industry corridor', 'Maritime skills academy'],
  },
  {
    id: 'south-west',
    name: 'South West',
    states: ['Ekiti', 'Lagos', 'Ogun', 'Ondo', 'Osun', 'Oyo'],
    headline: 'Unlock the country’s commercial engine.',
    detail:
      'Port decongestion at Apapa and Tin Can, regional rail linking Lagos to Ibadan and Abeokuta, and a technology corridor with predictable power for the continent’s densest startup cluster.',
    priorities: ['Port decongestion', 'Regional rail links', 'Technology corridor power'],
  },
]
